import {
  loginCaptchaResponseSchema,
  sessionResponseSchema,
  type LoginCaptchaResponse,
  type SessionResponse,
} from '@chatapp-inbox/shared';
import { isApiError, request, setCsrfToken } from './http';

/** Chave pública do reCAPTCHA do login (`siteKey: null` = desligado). Não exige sessão. */
export function fetchLoginCaptcha(signal?: AbortSignal): Promise<LoginCaptchaResponse> {
  return request('/auth/captcha', {
    schema: loginCaptchaResponseSchema,
    auth: 'public',
    ...(signal ? { signal } : {}),
  });
}

/**
 * Entra com e-mail e senha (e a resposta do reCAPTCHA, quando o login tem um). Guarda o token CSRF da
 * nova sessão para as próximas chamadas.
 */
export async function login(
  email: string,
  password: string,
  captcha?: string,
): Promise<SessionResponse> {
  const session = await request('/auth/login', {
    method: 'POST',
    body: captcha ? { email, password, captcha } : { email, password },
    schema: sessionResponseSchema,
    auth: 'public',
  });
  setCsrfToken(session.csrfToken);
  return session;
}

/** Sessão atual, ou null se não há ninguém conectado (cookie ausente/expirado). */
export async function fetchSession(signal?: AbortSignal): Promise<SessionResponse | null> {
  try {
    const session = await request('/auth/me', {
      schema: sessionResponseSchema,
      auth: 'public',
      ...(signal ? { signal } : {}),
    });
    setCsrfToken(session.csrfToken);
    return session;
  } catch (err) {
    if (isApiError(err) && err.status === 401) {
      setCsrfToken(null);
      return null;
    }
    throw err;
  }
}

/** Encerra a sessão no servidor. Se ela já tinha acabado (401), o objetivo foi atingido. */
export async function logout(): Promise<void> {
  try {
    await request('/auth/logout', { method: 'POST', auth: 'public' });
  } catch (err) {
    if (!(isApiError(err) && err.status === 401)) throw err;
  }
  setCsrfToken(null);
}
